import { l as _inherits, h as _createClass, d as _objectSpread2, i as _classCallCheck, m as _callSuper } from './_rollupPluginBabelHelpers-e71b1aad.js';
import React__default from 'react';
import PropTypes from 'prop-types';
import { o as occupancyShape, i as intlShape } from './PropTypes-e1e509ba.js';
import { N as NumberPicker, T as Tooltip } from './index-66c14c2a.js';
import { S as StateManagedSelect$1 } from './react-select.esm-8a3af7ca.js';
import { B as Button } from './Button-a16585e5.js';
import { I as Icon } from './index-11bc5ac3.js';
import { g as getClassName } from './utilsHelpers-e4b21f4b.js';
import 'moment';
import './_commonjsHelpers-17042db9.js';
import 'react-dom';
import './hoist-non-react-statics.cjs-50d12f04.js';
import './index-f5c6df27.js';

var RoomSelector = /*#__PURE__*/function (_React$Component) {
  function RoomSelector(props) {
    var _this;
    _classCallCheck(this, RoomSelector);
    _this = _callSuper(this, RoomSelector, [props]);
    _this.state = {
      isTooltipActive: false
    };
    // this.getDefaultChildAgeOption = this.getDefaultChildAgeOption.bind(this);
    // this.getSelectedChildAgeOption = this.getSelectedChildAgeOption(this);
    _this.getAllChildAgeOptions = _this.getAllChildAgeOptions.bind(_this);
    return _this;
  }
  _inherits(RoomSelector, _React$Component);
  return _createClass(RoomSelector, [{
    key: "getAllChildAgeOptions",
    value: function getAllChildAgeOptions(minChildAge, maxChildAge) {
      var _this2 = this;
      // We get rid of the -1 that can come in minChildAge and
      // add one to take into account the age under one year
      var realMinChildAge = minChildAge > 0 ? minChildAge : 0;
      var rangeAge = maxChildAge - realMinChildAge + 1;
      return maxChildAge || maxChildAge > 0 ? Array.from({
        length: rangeAge
      }, function (v, index) {
        var age = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : index + realMinChildAge;
        return {
          key: age,
          value: age,
          label: _this2.getDefaultChildAgeOption(age)
        };
      }) : null;
    }
  }, {
    key: "getSelectedChildAgeOption",
    value: function getSelectedChildAgeOption(age, options) {
      var selectedOption = options[0];
      options.forEach(function (option) {
        if (option.value === age) {
          selectedOption = option;
        }
      });
      return selectedOption;
    }
  }, {
    key: "getDefaultChildAgeOption",
    value: function getDefaultChildAgeOption(age) {
      var intl = this.props.intl;
      return age === 0 ? intl.formatMessage({
        id: 'bf.occupancy.childAgeSelectorLabelBelowZero',
        defaultMessage: 'bf.occupancy.childAgeSelectorLabelBelowZero'
      }) : intl.formatMessage({
        id: 'bf.yearsCount',
        defaultMessage: 'bf.yearsCount'
      }, {
        count: age
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props = this.props,
        childrenEnabled = _this$props.childrenEnabled,
        minOccupancy = _this$props.minOccupancy,
        maxOccupancy = _this$props.maxOccupancy,
        minChildAge = _this$props.minChildAge,
        maxChildAge = _this$props.maxChildAge,
        onChangeAdults = _this$props.onChangeAdults,
        onChangeChildren = _this$props.onChangeChildren,
        onRemoveRoom = _this$props.onRemoveRoom,
        onChangeChildrenAge = _this$props.onChangeChildrenAge,
        room = _this$props.room,
        roomIndex = _this$props.roomIndex,
        roomQuantity = _this$props.roomQuantity,
        getQAData = _this$props.getQAData,
        intl = _this$props.intl,
        allowRooms = _this$props.allowRooms;
      var childAgeOptions = this.getAllChildAgeOptions(minChildAge, maxChildAge);
      var numberOfChildren = childrenEnabled ? room.children.length : 0;
      var minAdults = minOccupancy - numberOfChildren <= 1 ? 1 : minOccupancy - numberOfChildren;
      var maxAdults = maxOccupancy - numberOfChildren;
      var minChildren = numberOfChildren > 0 && minOccupancy - room.adults > 0 ? minOccupancy - room.adults : 0;
      var maxChildren = childrenEnabled ? maxOccupancy - room.adults : 0;
      var adultsId = "adults-selector-wrapper-".concat(roomIndex);
      var childrenId = "children-selector-wrapper-".concat(roomIndex);
      var roomIndexToShow = roomIndex + 1;
      var showChildren = childrenEnabled && room.children.length > 0 && maxChildAge !== -1;
      var selectStyle = {
        control: function control(base, state) {
          return _objectSpread2(_objectSpread2({}, base), {}, {
            boxShadow: state.isFocused ? 0 : 0,
            '&:hover': {
              borderColor: state.isFocused ? 'rgba(0, 0, 0, 0.12)' : 'rgba(0, 0, 0, 0.12)'
            }
          });
        },
        placeholder: function placeholder(base) {
          return _objectSpread2(_objectSpread2({}, base), {}, {
            color: 'rgba(0,0,0,.95)'
          });
        },
        option: function option(base) {
          return _objectSpread2(_objectSpread2({}, base), {}, {
            color: 'rgba(0,0,0,.95)',
            whiteSpace: 'nowrap',
            '&:hover': {
              backgroundColor: 'rgba(0, 0, 0, 0.05)'
            }
          });
        },
        singleValue: function singleValue(base) {
          return _objectSpread2(_objectSpread2({}, base), {}, {
            color: 'rgba(0,0,0,.95)',
            fontWeight: 'semi-bold'
          });
        }
      };
      return /*#__PURE__*/React__default.createElement("div", {
        className: "row"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "room-occupancy-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "selectors-wrapper"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "selectors-center-wrapper"
      }, allowRooms ? /*#__PURE__*/React__default.createElement("div", {
        className: "room-occupancy-title-wrapper",
        id: "childrenId"
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "room-occupancy-title"
      }, intl.formatMessage({
        id: 'bf.roomNumber',
        defaultMessage: 'bf.roomNumber'
      }, {
        number: roomIndexToShow
      }))) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "adults-selector-wrapper",
        id: adultsId
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "adults-selector-label"
      }, intl.formatMessage({
        id: 'bf.adults',
        defaultMessage: 'bf.adults'
      })), /*#__PURE__*/React__default.createElement(NumberPicker, {
        circular: true,
        onChange: function onChange(e) {
          return onChangeAdults(roomIndex, e);
        },
        value: room.adults,
        min: minAdults,
        max: maxAdults,
        getQAData: getQAData,
        hasTooltip: true,
        tooltipParentSelector: "#".concat(adultsId),
        tooltipText: intl.formatMessage({
          id: 'bf.maxOccupancyMessage',
          defaultMessage: 'bf.maxOccupancyMessage'
        }, {
          count: maxOccupancy
        }),
        qaContext: {
          selector: 'occupancySelectorRoom',
          name: 'Adults',
          index: roomIndex
        }
      })), childrenEnabled ? /*#__PURE__*/React__default.createElement("div", {
        className: "children-selector-wrapper",
        id: childrenId
      }, /*#__PURE__*/React__default.createElement("div", {
        className: "children-selector-label"
      }, intl.formatMessage({
        id: 'bf.children',
        defaultMessage: 'bf.children'
      })), /*#__PURE__*/React__default.createElement(NumberPicker, {
        onChange: function onChange(e) {
          return onChangeChildren(roomIndex, e);
        },
        value: numberOfChildren,
        max: maxChildren,
        min: minChildren,
        getQAData: getQAData,
        hasTooltip: true,
        tooltipParentSelector: "#".concat(childrenId),
        tooltipText: intl.formatMessage({
          id: 'bf.maxOccupancyMessage',
          defaultMessage: 'bf.maxOccupancyMessage'
        }, {
          count: maxOccupancy
        }),
        qaContext: {
          selector: 'occupancySelectorRoom',
          name: 'Children',
          index: roomIndex
        },
        circular: true
      })) : null, /*#__PURE__*/React__default.createElement("div", {
        className: getClassName({
          empty: !showChildren
        }, 'children-age-selector-wrapper')
      }, showChildren && childAgeOptions.length > 0 ? room.children.map(function (childAge, childIndex) {
        var childSelectKey = "ROOM_".concat(roomIndex, "_CHILDREN_").concat(childIndex);
        var childAgeLabel = intl.formatMessage({
          id: 'bf.occupancy.childAgeSelectorLabel',
          defaultMessage: 'bf.occupancy.childAgeSelectorLabel'
        }, {
          index: childIndex + 1
        });
        var defaultChildAgeOption = _this3.getSelectedChildAgeOption(childAge, childAgeOptions);
        var placeholderChildAgeOption = _this3.getDefaultChildAgeOption(0);
        return /*#__PURE__*/React__default.createElement("div", {
          key: childSelectKey
        }, /*#__PURE__*/React__default.createElement("span", {
          className: "children-age-select-label"
        }, childAgeLabel), /*#__PURE__*/React__default.createElement(StateManagedSelect$1, {
          className: "children-age-select",
          onChange: function onChange(event) {
            return onChangeChildrenAge(roomIndex, childIndex, event.value);
          },
          options: childAgeOptions,
          defaultValue: defaultChildAgeOption,
          placeholder: placeholderChildAgeOption,
          styles: selectStyle,
          isSearchable: false,
          components: {
            IndicatorSeparator: function IndicatorSeparator() {
              return null;
            }
          },
          theme: function theme(_theme) {
            return _objectSpread2(_objectSpread2({}, _theme), {}, {
              borderRadius: 0,
              colors: _objectSpread2(_objectSpread2({}, _theme.colors), {}, {
                primary25: 'rgba(0,0,0,.03)',
                primary: 'rgba(0,0,0,.03)'
              })
            });
          }
        }));
      }) : null))), /*#__PURE__*/React__default.createElement("div", {
        className: "delete-button-wrapper"
      }, roomQuantity > 1 ? /*#__PURE__*/React__default.createElement(Button, {
        primary: true,
        onClick: function onClick() {
          return onRemoveRoom(roomIndex);
        },
        type: "button",
        size: "small"
      }, /*#__PURE__*/React__default.createElement(Icon, {
        name: "bf-icon-trash-bin",
        size: "small"
      })) : null)));
    }
  }]);
}(React__default.Component);
RoomSelector.defaultProps = {
  allowRooms: true,
  // When is not active QA retrieve an empty object
  getQAData: function getQAData() {
    return {};
  }
};
RoomSelector.propTypes = {
  room: PropTypes.shape(occupancyShape).isRequired,
  roomQuantity: PropTypes.number.isRequired,
  roomIndex: PropTypes.number.isRequired,
  childrenEnabled: PropTypes.bool.isRequired,
  minChildAge: PropTypes.number.isRequired,
  maxChildAge: PropTypes.number.isRequired,
  maxOccupancy: PropTypes.number.isRequired,
  minOccupancy: PropTypes.number.isRequired,
  allowRooms: PropTypes.bool,
  onChangeAdults: PropTypes.func.isRequired,
  onChangeChildren: PropTypes.func.isRequired,
  onChangeChildrenAge: PropTypes.func.isRequired,
  onRemoveRoom: PropTypes.func.isRequired,
  intl: PropTypes.shape(intlShape).isRequired,
  getQAData: PropTypes.func
};

var getChildrenQuantity = function getChildrenQuantity(occupancy) {
  return occupancy.reduce(function (total, room) {
    return total + room.children.length;
  }, 0);
};
var getAdultsQuantity = function getAdultsQuantity(occupancy) {
  return occupancy.reduce(function (total, room) {
    return total + room.adults;
  }, 0);
};
var OccupancySelectorContent = /*#__PURE__*/function (_React$Component) {
  function OccupancySelectorContent(props) {
    var _this;
    _classCallCheck(this, OccupancySelectorContent);
    _this = _callSuper(this, OccupancySelectorContent, [props]);
    _this.state = {
      isTooltipActive: false,
      isOpen: false
    };
    _this.renderTooltip = _this.renderTooltip.bind(_this);
    _this.showTooltip = _this.showTooltip.bind(_this);
    _this.hideTooltip = _this.hideTooltip.bind(_this);
    return _this;
  }
  _inherits(OccupancySelectorContent, _React$Component);
  return _createClass(OccupancySelectorContent, [{
    key: "showTooltip",
    value: function showTooltip() {
      this.setState({
        isTooltipActive: true
      });
    }
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      this.setState({
        isTooltipActive: false
      });
    }
  }, {
    key: "renderTooltip",
    value: function renderTooltip() {
      var _this$props = this.props,
        occupancy = _this$props.occupancy,
        maxRoomsPerBooking = _this$props.maxRoomsPerBooking,
        intl = _this$props.intl;
      var message = intl.formatMessage({
        id: 'bf.maxRoomsPerBooking',
        defaultMessage: 'bf.maxRoomsPerBooking'
      }, {
        count: maxRoomsPerBooking
      });
      var isTooltipActive = this.state.isTooltipActive;
      var active = isTooltipActive && occupancy.length >= maxRoomsPerBooking;
      return /*#__PURE__*/React__default.createElement(Tooltip, {
        active: active,
        parent: ".add-room-button-wrapper",
        message: message
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        occupancy = _this$props2.occupancy,
        minChildAge = _this$props2.minChildAge,
        maxChildAge = _this$props2.maxChildAge,
        maxOccupancy = _this$props2.maxOccupancy,
        minOccupancy = _this$props2.minOccupancy,
        maxRoomsPerBooking = _this$props2.maxRoomsPerBooking,
        childrenEnabled = _this$props2.childrenEnabled,
        allowRooms = _this$props2.allowRooms,
        intl = _this$props2.intl,
        onChangeAdults = _this$props2.onChangeAdults,
        onChangeChildren = _this$props2.onChangeChildren,
        onChangeChildrenAge = _this$props2.onChangeChildrenAge,
        onChangeRoomsQuantity = _this$props2.onChangeRoomsQuantity,
        onRemoveRoom = _this$props2.onRemoveRoom,
        getQAData = _this$props2.getQAData;
      var tooltip = this.renderTooltip();
      return /*#__PURE__*/React__default.createElement("div", {
        className: "bf-occupancy-selector-content"
      }, occupancy.map(function (room, roomIndex) {
        var key = "ROOM_".concat(roomIndex, "_OCCUPANCY");
        return /*#__PURE__*/React__default.createElement(RoomSelector, {
          id: key,
          key: key,
          room: room,
          roomQuantity: occupancy.length,
          roomIndex: roomIndex,
          childrenEnabled: childrenEnabled,
          minChildAge: minChildAge,
          maxChildAge: maxChildAge,
          maxOccupancy: maxOccupancy,
          minOccupancy: minOccupancy,
          allowRooms: allowRooms,
          onChangeAdults: onChangeAdults,
          onChangeChildren: onChangeChildren,
          onChangeChildrenAge: onChangeChildrenAge,
          onRemoveRoom: onRemoveRoom,
          getQAData: getQAData,
          intl: intl
        });
      }), /*#__PURE__*/React__default.createElement("div", {
        className: "row row-footer"
      }, allowRooms ? /*#__PURE__*/React__default.createElement("div", {
        className: "add-room-button-wrapper"
      }, tooltip, /*#__PURE__*/React__default.createElement("a", {
        className: "add-room-button ".concat(occupancy.length >= maxRoomsPerBooking ? 'disabled' : ''),
        onClick: function onClick() {
          if (occupancy.length < maxRoomsPerBooking) {
            return onChangeRoomsQuantity(occupancy.length + 1);
          }
        },
        onMouseEnter: this.showTooltip,
        onMouseLeave: this.hideTooltip
      }, "+ ", intl.formatMessage({
        id: 'widgets.reservations.room.add',
        defaultMessage: 'widgets.reservations.room.add'
      }))) : null, /*#__PURE__*/React__default.createElement("div", {
        className: "occupancy-selector-summary"
      }, allowRooms ? intl.formatMessage({
        id: 'bf.occupancy.dropdown.summary',
        defaultMessage: 'bf.occupancy.dropdown.summary'
      }, {
        adults: getAdultsQuantity(occupancy),
        children: getChildrenQuantity(occupancy),
        rooms: occupancy.length
      }) : intl.formatMessage({
        id: 'bf.occupancy.dropdown.summary.without.room',
        defaultMessage: 'bf.occupancy.dropdown.summary.without.room'
      }, {
        adults: getAdultsQuantity(occupancy),
        children: getChildrenQuantity(occupancy)
      }))));
    }
  }]);
}(React__default.Component);
OccupancySelectorContent.defaultProps = {
  allowRooms: true,
  getQAData: function getQAData() {
    return {};
  }
};
OccupancySelectorContent.propTypes = {
  childrenEnabled: PropTypes.bool.isRequired,
  minChildAge: PropTypes.number.isRequired,
  maxChildAge: PropTypes.number.isRequired,
  maxOccupancy: PropTypes.number.isRequired,
  maxRoomsPerBooking: PropTypes.number.isRequired,
  minOccupancy: PropTypes.number.isRequired,
  allowRooms: PropTypes.bool,
  occupancy: PropTypes.arrayOf(PropTypes.shape(occupancyShape)).isRequired,
  onChangeRoomsQuantity: PropTypes.func.isRequired,
  onRemoveRoom: PropTypes.func.isRequired,
  onChangeAdults: PropTypes.func.isRequired,
  onChangeChildren: PropTypes.func.isRequired,
  onChangeChildrenAge: PropTypes.func.isRequired,
  intl: PropTypes.shape(intlShape).isRequired,
  getQAData: PropTypes.func
};

export default OccupancySelectorContent;
//# sourceMappingURL=OccupancySelectorContent.js.map
